<template>
    <div>
        <table class="at-table full-with">
            <thead>
                <tr>
                    <th>课程名称</th>
                    <th style="width: 150px">赠送时间</th>
                    <th style="width: 104px">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in videos" :key="index">
                    <td style="padding: 8px">
                        <a-select v-model="item.id" class="full-with at-select" show-search :filter-option="false" @search="handleSearch">
                            <template v-for="(course) in courses">
                                <a-select-option :value="course.id" :key="course.id">{{ course.title }}</a-select-option>
                            </template>
                        </a-select>
                    </td>
                    <td>
                        <days-select v-model="item.day" :show-zero="false"></days-select>
                    </td>
                    <td>
                        <button class="btn btn-danger outline" @click="removeRow(index)">删除</button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="3">
                        <button class="btn" @click="addRow">添加赠送视频课程</button>
                    </th>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import api from "@/repo/api";
    import DaysSelect from "@/components/DaysSelect.vue";
    
    export default {
        name:"CourseVideoBranchPicker",
        components: {DaysSelect},
        props:{
            videos: {
                type:Array,
            }
        },
        model:{
            prop:'videos',
            event:'change'
        },
        data(){
            return {
                courses:[],
                query:{
                    group:"courses",
                    page:1,
                    keywords:"",
                    order_by_ids:[],
                    type:"video"
                },
            }
        },
        mounted() {
            this.query.order_by_ids = this.videos.map(item => item.id)
            this.fetchCourse()
        },
        methods:{
            fetchCourse(){
                return new Promise((resolve, reject) => {
                    api.get('/course/list', this.query, (data) => {
                        if (data.code != 0) {
                            reject(data.msg)
                            return
                        }
                        this.courses = data.data.data
                        resolve()
                    })
                })
            },
            handleSearch(val){
                this.query.keywords = val
                this.fetchCourse()
            },
            addRow(){
                let videos = this.videos ? [...this.videos] : []
                videos.push({
                    id: '',
                    day: '',
                })
                this.$emit('change', videos)
            },
            removeRow(row){
                let videos = this.videos ? [...this.videos] : []
                let idx = videos.findIndex((item) => item.id == row.id)
                videos.splice(idx, 1)
                this.$emit('change', videos)
            }
        }
    }
</script>

<style></style>